(() => {
  'use strict';
  if (window.CBCuratedSeries?.version === 2) {
    window.CBCuratedSeries.init(document);
    return;
  }
  window.CBCuratedSeries?.dispose?.();
  const lifecycle = new AbortController();
  const normalize = value => String(value || '').toLocaleLowerCase('en').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  function mount(root) {
    if (root._cbcs?.version === 2) return;
    root._cbcs?.destroy();
    const cards = Array.from(root.querySelectorAll('[data-cbcs-card]'));
    const filters = Array.from(root.querySelectorAll('[data-cbcs-filter]'));
    const filterValues = new Set(filters.map(button => button.dataset.cbcsFilter));
    const find = selector => root.querySelector(selector);
    const input = find('[data-cbcs-search]');
    const form = find('[data-cbcs-search-form]');
    const clear = find('[data-cbcs-clear]');
    const resetButton = find('[data-cbcs-reset]');
    const count = find('[data-cbcs-count]');
    const empty = find('[data-cbcs-empty]');
    if (![input,form,clear,resetButton,count,empty].every(Boolean) || !filters.length) return;
    const controller = new AbortController();
    const signal = controller.signal;
    let activeFilter = 'all';
    let query = '';
    const render = () => {
      const term = normalize(query);
      let visible = 0;
      cards.forEach(card => {
        const show = (activeFilter === 'all' || card.dataset.style === activeFilter) && (!term || normalize(card.dataset.title).includes(term));
        card.hidden = !show;
        if (show) visible += 1;
      });
      filters.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.cbcsFilter === activeFilter)));
      count.textContent = (visible === 1 ? root.dataset.countOne : root.dataset.countMany).replace('__count__',String(visible));
      clear.hidden = query.length === 0;
      empty.hidden = visible > 0;
    };
    const reset = () => {activeFilter = 'all';query = '';input.value = '';render();};
    filters.forEach(button => button.addEventListener('click',() => {
      if (!filterValues.has(button.dataset.cbcsFilter)) return;
      activeFilter = button.dataset.cbcsFilter;
      render();
    },{signal}));
    input.addEventListener('input',() => {query = input.value;render();},{signal});
    form.addEventListener('submit',event => event.preventDefault(),{signal});
    form.addEventListener('keydown',event => {if (event.key === 'Escape') {event.preventDefault();query = '';input.value = '';render();input.focus();}},{signal});
    clear.addEventListener('click',() => {query = '';input.value = '';render();input.focus();},{signal});
    resetButton.addEventListener('click',() => {reset();filters[0].focus();},{signal});
    const controls = [input,...filters];
    controls.forEach(control => {control.disabled = false;});
    root.classList.add('is-enhanced');
    root._cbcs = {
      version:2,
      reveal(blockId) {
        const selected = cards.find(card => card.dataset.cbcsBlock === String(blockId));
        if (!selected) return;
        reset();
        selected.scrollIntoView({block:'center',behavior:'instant'});
      },
      destroy() {
        if (signal.aborted) return;
        controller.abort();
        reset();
        controls.forEach(control => {control.disabled = true;});
        root.classList.remove('is-enhanced');
        delete root._cbcs;
      }
    };
    render();
  }
  function rootsWithin(target) {
    if (!target?.querySelectorAll) return [];
    const roots = Array.from(target.querySelectorAll('[data-cbcs-section]'));
    if (target.matches?.('[data-cbcs-section]')) roots.unshift(target);
    return roots;
  }
  const init = target => rootsWithin(target).forEach(mount);
  const api = {init,version:2,dispose() {lifecycle.abort();rootsWithin(document).forEach(root => root._cbcs?.destroy());if (window.CBCuratedSeries === api) delete window.CBCuratedSeries;}};
  window.CBCuratedSeries = api;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document),{once:true,signal:lifecycle.signal});
  else init(document);
  document.addEventListener('shopify:section:load',event => init(event.target),{signal:lifecycle.signal});
  document.addEventListener('shopify:section:unload',event => rootsWithin(event.target).forEach(root => root._cbcs?.destroy()),{signal:lifecycle.signal});
  document.addEventListener('shopify:block:select',event => {
    const blockId = event.detail?.blockId || event.target.closest('[data-cbcs-block]')?.dataset.cbcsBlock;
    const root = event.target.closest('[data-cbcs-section]') || document.getElementById('CbCuratedSeries-' + event.detail?.sectionId);
    root?._cbcs?.reveal(blockId);
  },{signal:lifecycle.signal});
})();
